export const MEDIA_GRID_MD = '900px';
export const SCROLL_DURATION = 270;
export const PAGE_OFFSET = 78;
export const SCROLL_OFFSET = 0 - PAGE_OFFSET;
export const WAYPOINT_OFFSET = 1 + PAGE_OFFSET;
export const JS_JOIN_HOOK = 'js-open-popup-join';
export const FIT_MODAL_CLASS = 'gig_page_perseus';
export const GTM_EVENT_NAME = 'gig_page_load';
